import { CLICK, component, demoFile, feature, INPUT, POPUP, story, variant, componentWithVariants, extend, extendWithVariants } from "system/demo";
import { ComposerPerspectiveSelector, MissingPerspectivesCard, PerspectivesForComment, PerspectiveFilter, PerspectiveToggle, PerspectivesSubtleBubble, ComposerPerspectiveSelectorWithWriteIn } from 'feature/question/representing-perspectives';
import { useState } from "react";
import { BasicComments, Composer, ComposerAndComments } from "component/comment";
import { View } from "react-native";

demoFile('feature/question/representing-perspectives', {
    designUrl: 'https://www.figma.com/design/3vGCewqJoClk1vyiptYeon/Representing-Perspectives---Testing?node-id=898-1334&m=dev'
});

const globals = {perspectives: '👩‍👧‍👦 Parent\n👧 Child\n👨‍🏫 Teacher\n👩‍💼 School Administrator\nEmojiless Person'}
const collections = {comment: [
    {from: 'a', text: 'a comment', perspectives: {Parent: {emoji: '👩‍👧‍👦', text: 'Parent'}, Child: {emoji: '👧', text: 'Child'}}}
]}

component('MissingPerspectivesCard', MissingPerspectivesCard, {
    state: {
        globals,
        collections,
        roles: ['Editorial']
    }
});

const standardComment = {from: 'a', text: 'a comment', perspectives: {Parent: {emoji: '👩‍👧‍👦', text: 'Parent'}, Child: {emoji: '👧', text: 'Child'}}}

component('PerspectivesForComment', PerspectivesForComment, {
    args: {comment: standardComment}
});

componentWithVariants('MissingPerspectivesCard', MissingPerspectivesCard, {}, [
    variant('Wrote an answer', {
        state: {globals, collections}
    }),
    variant('Have not answered', {
        state: {globals, collections, personaKey: 'b'}
    }),
    variant('No comments yet', {
        state: {globals}
    }),
    variant('All perspectives present', {
        state: {
            globals: {perspectives: '👩‍👧‍👦 Parent\n👧 Child'},
            collections
        }
    })
]);

function PerspectiveToggleDemo() {
    const [comment, setComment] = useState(standardComment)
    return <PerspectiveToggle comment={comment} setComment={setComment} perspective={{emoji: '👩‍👧‍👦', text: 'Parent'}} />
}

component('PerspectiveToggle', PerspectiveToggleDemo, {
    args: {comment: standardComment}
}, [
    story('Toggle Parent', [
        CLICK('Parent')
    ])
]);

component('PerspectiveFilter', PerspectiveFilter, {
    args: {comment: standardComment},
    state: {
        globals,
        collections
    },
    config: {
        perspectiveShowFilter: true
    }
}, [
    story('Parent', [
        CLICK('Sort by perspective'),
        POPUP(CLICK('Parent')),
        POPUP(CLICK('Apply'))
    ])
]); 

componentWithVariants('PerspectivesSubtleBubble', PerspectivesSubtleBubble, {}, [
    variant(null, {
        state: {
            globals:  {perspectives: '🐾 Animal Rights Activist\n🗽 New York Resident'},
        }
    }, [
        story('Navigate to Perspective', [
            CLICK('Animal Rights Activist')
        ])
    ]),
    variant('Empty')
]);

function ComposerPerspectiveSelectorDemo() {
    const [comment, setComment] = useState(standardComment)
    return <ComposerPerspectiveSelector comment={comment} setComment={setComment} />
}

component('ComposerPerspectiveSelector', ComposerPerspectiveSelectorDemo, {
    state: {globals, collections}
}, [
    story('Parent', [
        CLICK('Parent')
    ])
]);

function ComposerPerspectiveSelectorWithWriteInDemo() {
    const [comment, setComment] = useState(standardComment)
    return <ComposerPerspectiveSelectorWithWriteIn comment={comment} setComment={setComment} />
}


component('ComposerPerspectiveSelectorWithWriteIn', ComposerPerspectiveSelectorWithWriteInDemo, {
    state: {
        globals, collections,
        serverCall: {moderation: {
            checkPerspectiveWithGpt: async ({perspectiveText}) => 
                ({violates: perspectiveText === 'bad perspective', rulesBroken: [1, 2]})
        }}
    }
}, [
    story('Add bad perspective', [
        CLICK('Add your own'),
        INPUT('write-in-perspective','bad perspective'),
        CLICK('Add'),
    ]),
    story('Add good perspective', [
        CLICK('Add your own'),
        INPUT('write-in-perspective','good perspective'),
        CLICK('Add'),
    ])
]);

extendWithVariants('ComposerAndComments', 'Perspectives', ComposerAndComments, {}, [
    variant('Preselected Perspective', {
        structureKey: 'question',
        features: ['representing_perspectives', 'representing_perspectives_speech_bubble'],
        state: {
            globals,
            screenParams: {
                preselectedPerspectiveText: 'Child'
            }
        }
    }, [
        story('Post with selected', [
            INPUT('comment-edit', 'I am a child'),
            CLICK('Post')
        ])
    ])
])

const comments = [
    {key: 1, from: 'a', text: 'Lead it away with food', perspectives: {"Animal Rights Activist": {"emoji":"🐾","text":"Animal Rights Activist"}}},
    {key: 2, from: 'b', text: 'Blow it up', perspectives: {"Military Leader": {"emoji":"🪖","text":"Military Leader"}}},
    {key: 3, from: 'c', text: "I don't know, but it just destroyed my house", perspectives: {"New York Resident": {"emoji":"🗽","text":"New York Resident"}}},
    {key: 4, from: 'd', text: "Make friends with it", perspectives: {writeIn: { 
        text: 'writeInText', 
        violates: true, 
        violations: ['No insults, mockery, threats, or personal attacks']}
    }}
]

feature('representing_perspectives', {
    structureKey: 'question',
    features: {
        representing_perspectives: true,
        representing_perspectives_card: true,
        representing_perspectives_subtle_bubble: false,
        representing_perspectives_speech_bubble: false,
        reactiontypes: false
    },
    state: {
        roles: ['Editoral'],
        globals: {
            name: 'What should we do about the Giant Gorilla rampaging New York City?',
            perspectives: '🗽 New York Resident\n🐾 Animal Rights Activist\n🏙️ City Planner\n🪖 Military Leader',
            questionAuthor: 'a',
            questionTime: Date.now(),
        },
        collections: {comment: comments}
    }
})

